import { Capacitor } from '@capacitor/core';
import { FcmPush } from '@/services/fcm-push.plugin';
import { HmsPush } from '@/services/hms-push.plugin';

let lastSuppress: boolean | null = null;

/**
 * When messenger UI is open, hide foreground push banners (iOS / HMS).
 * WebSocket and pushNotificationReceived still update unread badges.
 */
export async function syncMessengerPushBannerSuppress(suppress: boolean): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  if (lastSuppress === suppress) return;
  lastSuppress = suppress;

  if (Capacitor.getPlatform() === 'ios') {
    try {
      await FcmPush.setSuppressMessengerBanners({ suppress });
    } catch (e) {
      console.warn('[push] setSuppressMessengerBanners (iOS) failed', e);
    }
  }

  try {
    await HmsPush.setSuppressMessengerBanners({ suppress });
  } catch {
    /* play flavor stub may not implement the method */
  }
}
